import { FC } from "react";
import { Text } from "shared/components/Spor";

export const GlobalEventWarningText: FC = () => (
  <Text variant="sm" width="100%">
    <span style={{ fontWeight: "bold" }}>OBS!</span> Globale driftsmeldinger
    blir synlig for alle kunder i alle kundekanaler
  </Text>
);
